import { CLICK_TO, CLICK_TO_OPEN, SEE_ALL_COUPONS } from "@cart-ui/constants";
import { SavingsLineItemRightSection, SavingsLineItemSubtitle, SavingsLineItemTitle } from "@swiggy-private/cart-types";

export const getSavingsLineItemAccessibilityTexts = ({
    title,
    subtitle,
    rightSection,
    onLineItemClick,
}: {
    title: SavingsLineItemTitle;
    subtitle: SavingsLineItemSubtitle;
    rightSection: SavingsLineItemRightSection;
    onLineItemClick?: VoidFunction;
}) => {
    let titleText = "",
        subtitleText = "",
        rightSectionText = "";

    if (typeof onLineItemClick === "function") {
        titleText = `${subtitle?.value || ""} ${SEE_ALL_COUPONS}`;
    }
    if (typeof subtitle?.onClick === "function" && !subtitle?.subtitleNode) {
        titleText = title?.value || "";
        subtitleText = `${subtitle?.value || ""}. ${CLICK_TO_OPEN}`;
    }
    if (typeof rightSection?.onClick === "function") {
        titleText = title?.value || "";
        rightSectionText = `${CLICK_TO} ${rightSection?.value || ""}`;
    }
    if (title?.titleNode) {
        titleText = "";
    }

    return {
        titleText,
        subtitleText,
        rightSectionText,
    };
};
